import React, { useState, useRef, useEffect } from 'react';
import { FaTimes, FaEye, FaEyeSlash } from 'react-icons/fa';
import CustomPhoneInput from '../PhoneInput';
import { toast } from 'react-toastify';



const AddCustomerPopup = ({ onClose, onSuccess }) => {
    const [newCustomer, setNewCustomer] = useState({
      email: '', password: '', name: '', role: 'user', mobileNumber: '', location: '', description: ''
    });
    const [showPassword, setShowPassword] = useState(false);
    const popupRef = useRef(null);
  
    useEffect(() => {
      const handleClickOutside = (event) => {
        if (popupRef.current && !popupRef.current.contains(event.target)) onClose();
      };
      document.addEventListener('mousedown', handleClickOutside);
      return () => document.removeEventListener('mousedown', handleClickOutside);
    }, [onClose]);
  
    const handleInputChange = (e) => {
      const { name, value } = e.target;
      setNewCustomer(prev => ({ ...prev, [name]: value }));
    };
  
    const handlePhoneChange = (phone) => {
      setNewCustomer(prev => ({ ...prev, mobileNumber: phone }));
    };
  
    const validateForm = () => {
      if (!newCustomer.name.trim()) {
        toast.error('Error adding client: Name is required');
        return false;
      }
      if (!newCustomer.mobileNumber.trim()) {
        toast.error('Error adding client: Mobile number is required');
        return false;
      }
      if (!newCustomer.description.trim()) {
        toast.error('Error adding client: Description is required');
        return false;
      }
      return true;
    };
  
    const handleSubmit = async (e) => {
      e.preventDefault();
  
      // Validate required fields before submitting
      if (!validateForm()) return;
  
      try {
        const response = await fetch(`${process.env.REACT_APP_SERVER_API}/api/register`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(newCustomer)
        });
        if (response.ok) {
          const data = await response.json();
          onSuccess(data.user);
        } else {
          const errorData = await response.json();
          if (errorData.error === "User with this email already exists") 
  
  {
            toast.error('Error adding client: User with this email already exists');
          } else {
            toast.error(`Error adding client: ${errorData.error || 'Unknown error'}`);
          }
        }
      } catch (error) {
        console.error('Error adding customer:', error);
        toast.error('Error adding client: Something went wrong!');
      }
    };
  
    return (
      <div className="fixed inset-0 bg-gray-600 bg-opacity-50 flex items-center justify-center z-50">
        <div ref={popupRef} className="bg-white p-6 rounded-lg shadow-xl w-full max-w-md relative">
          <button onClick={onClose} className="absolute top-2 right-2 text-gray-600 hover:text-gray-800">
            <FaTimes size={20} />
          </button>
          <h3 className="text-xl font-bold mb-4">Add New Client</h3>
          <form onSubmit={handleSubmit}>
            <div className="mb-4">
              <input
                type="text"
                name="name"
                value={newCustomer.name}
                onChange={handleInputChange}
                placeholder="Name"
                className="w-full p-2 border rounded"
                required
              />
            </div>
            <div className="mb-4">
              <input
                type="email"
                name="email"
                value={newCustomer.email}
                onChange={handleInputChange}
                placeholder="Email"
                className="w-full p-2 border rounded"
                required
              />
            </div>
            <div className="mb-4 relative">
              <input
                type={showPassword ? 'text' : 'password'}
                name="password"
                value={newCustomer.password}
                onChange={handleInputChange}
                placeholder="Password"
                className="w-full p-2 border rounded"
                required
              />
              <button
                type="button"
                onClick={() => setShowPassword(!showPassword)}
                className="absolute right-2 top-1/2 transform -translate-y-1/2 text-gray-500"
              >
                {showPassword ? <FaEyeSlash /> : <FaEye />}
              </button>
            </div>
            <div className="mb-4">
              <select name="role" value={newCustomer.role} onChange={handleInputChange} className="w-full p-2 border rounded">
                <option value="user">User</option>
                <option value="qa">qa</option>
              </select>
            </div>
            <div className="mb-4">
              <CustomPhoneInput value={newCustomer.mobileNumber} onChange={handlePhoneChange} />
            </div>
            <div className="mb-4">
              <input
                type="text"
                name="location"
                value={newCustomer.location}
                onChange={handleInputChange}
                placeholder="Location"
                className="w-full p-2 border rounded"
              />
            </div>
            <div className="mb-4">
              <textarea
                name="description"
                value={newCustomer.description}
                onChange={handleInputChange}
                placeholder="Description"
                className="w-full p-2 border rounded"
             
              />
            </div>
            <div className="flex justify-end space-x-2">
              <button type="button" onClick={onClose} className="px-4 py-2 bg-gray-300 rounded hover:bg-gray-400">Cancel</button>
              <button type="submit" className="px-4 py-2 bg-indigo-600 text-white rounded hover:bg-indigo-700">Add</button>
            </div>
          </form>
        </div>
      </div>
    );
  };
  
  export default AddCustomerPopup;